import React, { useMemo } from 'react';
import { Card } from '@chaser/components';
import useOrganisation from '../../../../hooks/useOrganisation';
import NavigationTabs from '../../../../components/NavigationTabs';
import { TabPanel, TabPanels } from '@chaser/components';
import ImportService from '../../../../services/import-service';
import useFetch from '../../../../hooks/useFetch';
import DataUpload from '../DataUpload';
import PDFUpload from '../PDFUpload';

const Upload = () => {
  const { ShortCode } = useOrganisation();
  const { data: csvMappingSpecification } = useFetch(
    ImportService.getCSVMappingSpecification,
    ShortCode,
  );

  const tabs = useMemo(() => {
    if (!csvMappingSpecification || !ShortCode) {
      return [];
    }

    const { types, maxCsvSize, maxPdfSize } = csvMappingSpecification;
    const tabsFromTypes =
      types.map(type => ({
        path: type.id,
        title: type.name,
        Component: () => <DataUpload type={type} shortCode={ShortCode} maxFileSize={maxCsvSize} />,
      })) || [];

    const invoicesIndex = tabsFromTypes.findIndex(type => type.path === 'invoices');

    if (invoicesIndex !== -1) {
      tabsFromTypes.splice(invoicesIndex + 1, 0, {
        path: 'invoice-pdfs',
        title: 'Invoice PDFs',
        Component: () => <PDFUpload shortCode={ShortCode} maxFileSize={maxPdfSize} />,
      });
    }

    return tabsFromTypes;
  }, [ShortCode, csvMappingSpecification]);

  return (
    <Card p="medium">
      <NavigationTabs basePath="/import/upload" tabs={tabs}>
        <TabPanels>
          {tabs.map(({ path, Component }) => (
            <TabPanel key={path}>
              <Component />
            </TabPanel>
          ))}
        </TabPanels>
      </NavigationTabs>
    </Card>
  );
};

Upload.propTypes = {};

export default Upload;
